import { Button, Grid, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { DEBUG_ACTION_SIZE, DEBUG_DESCRIPTION_SIZE } from './DebugModal';
import { ProjectServiceConnector } from '@/modules/api/ProjectApiConnector';
import { logger } from '@common/logging/logger';

export const OpenAllFloorplanButton = () => {
  const { projectId } = useParams();
  const loadAll = useCallback(async () => {
    if (!projectId) {
      logger.error('Expected projectId to be defined');
      return;
    }

    const allAlternatives = await ProjectServiceConnector.getInstance().getLayoutAlternatives({
      projectId,
    });
    allAlternatives.forEach((item) => {
      window.open(`/${projectId}/builder/${item.alternativeId}/version/${item.lastRevisionId}`);
    });
  }, [projectId]);

  return (
    <>
      <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
        <Typography>Open all floorplans in new tab</Typography>
      </Grid>
      <Grid item xs={DEBUG_ACTION_SIZE}>
        <Button onClick={loadAll}>Click</Button>
      </Grid>
    </>
  );
};
